import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Get auth token from localStorage
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

const intakeFormService = {
  // Create a new intake form
  async createIntakeForm(intakeFormData) {
    const response = await axios.post(
      `${API_URL}/intake-form`,
      intakeFormData,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get all intake forms
  async getIntakeForms() {
    const response = await axios.get(
      `${API_URL}/intake-form`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get intake form by ID
  async getIntakeFormById(id) {
    const response = await axios.get(
      `${API_URL}/intake-form/${id}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Get intake forms for a specific patient
  async getIntakeFormsByPatientId(patientId) {
    const response = await axios.get(
      `${API_URL}/intake-form/patient/${patientId}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Alias for consistency
  async getIntakeFormsByPatient(patientId) {
    return this.getIntakeFormsByPatientId(patientId);
  },

  // Alias for consistency with getIntakeFormById
  async getIntakeForm(id) {
    return this.getIntakeFormById(id);
  },

  // Alias for consistency
  async getPatients() {
    return this.getPatientsList();
  },

  // Update intake form
  async updateIntakeForm(id, intakeFormData) {
    const response = await axios.patch(
      `${API_URL}/intake-form/${id}`,
      intakeFormData,
      getAuthHeaders()
    );
    return response.data;
  },

  // Delete intake form
  async deleteIntakeForm(id) {
    const response = await axios.delete(
      `${API_URL}/intake-form/${id}`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Update intake form status
  async updateIntakeFormStatus(id, status) {
    const response = await axios.patch(
      `${API_URL}/intake-form/${id}/status`,
      { status },
      getAuthHeaders()
    );
    return response.data;
  },

  // Get list of all patients for selection
  async getPatientsList() {
    const response = await axios.get(
      `${API_URL}/intake-form/patients/list`,
      getAuthHeaders()
    );
    return response.data;
  },

  // Upload PDF and create intake form
  async uploadPdfAndCreateIntakeForm(file, patientId = null) {
    const formData = new FormData();
    formData.append('file', file);

    const url = patientId
      ? `${API_URL}/intake-form/upload-pdf?patientId=${patientId}`
      : `${API_URL}/intake-form/upload-pdf`;

    const token = localStorage.getItem('authToken');
    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Get remaining intake form requests
  async getRemainingRequests() {
    const response = await axios.get(
      `${API_URL}/intake-form/remaining-requests`,
      getAuthHeaders()
    );
    return response.data;
  }
};

export { intakeFormService };